<app-select-buttons
  [Buttons]="Buttons"
  [ToggledButtons]="ToggledButtons"
  [IsMultiple]="IsMultiple"
  (SelectedItems)="toggleSelect($event)"
  ><app-select-buttons> </app-select-buttons
></app-select-buttons>
